import { useEffect, useState } from 'react'
import { getCustomerSessionToken } from '../cookies/session.cookies'
import { getCustomerPunchCards } from './client'
import { CustomerPunchCard } from './types'

export function useCustomerPunchCards(
  establishmentUuid: string,
  establishmentId: string,
): CustomerPunchCard[] {
  const [cards, setCards] = useState<CustomerPunchCard[]>([])
  const token = getCustomerSessionToken(establishmentId)

  useEffect(() => {
    if (!token || !establishmentUuid) {
      setCards([])
      return
    }
    getCustomerPunchCards(establishmentUuid, token)
      .then(setCards)
      .catch(() => setCards([]))
  }, [establishmentUuid, token])

  return cards
}
